import React from "react";
import { infoColor, successColor, systemMessageColor } from "./color";
import { t } from "@lingui/macro";
import { trans } from "../config/LinguiConfig";
import {
    isBotMessage,
    isCustomerMessage,
    isSellerPrivateMessage,
    isSystemMessage,
    MessageType,
} from "@doopage-client-js/common";

export const CHAT_MODE = {
    single: "single",
    multi: "multi",
};

export const MAP_MESSAGE_TYPE_DETAIL = {
    customer_comment: 10,
    customer_message: 11,
    seller_message: 20,
    image_message: 21,
    reply_comment: 22,
    review: 23,
    other_seller_message: 30,
    doopage_bot: 80,
    system_internal_seller_message: 81,
    system_order_message: 90,
    system_product_message: 91,
    system_product_image: 92,
    system_confirm_order: 93,
    system_feedback: 94,
    system_auto_reply: 95,
};

export const getTitlePageMessage = (type, platform_name = "") => {
    const messages = {
        10: () => trans(t`Comment tại:`) + `  ${platform_name}`, //customer_comment
        11: () => trans(t`Inbox tại:`) + `  ${platform_name}`, //customer_message
        20: () => trans(t`Trả lời tại:`) + `  ${platform_name}`,
        21: () => trans(t`Trả lời tại:`) + `  ${platform_name}`,
        22: () => trans(t`Trả lời tại:`) + `  ${platform_name}`,
        30: () => trans(t`Khách hàng sẽ không nhìn thấy tin nhắn này`),
        80: () => trans(t`Doopage Bot`), //doopage_bot
        81: () => trans(t`đã đóng tư vấn`),
        90: () => trans(t`Hệ thống`),
        91: () => trans(t`Hệ thống`), //system_order_message
        92: () => trans(t`Hệ thống`),
        93: () => trans(t`Xác nhận đơn hàng`),
        94: () => trans(t`Phản hồi khách hàng`),
        95: () => trans(t`Tin nhắn tự động`),
    };

    return messages[type] ? messages[type]() : "";
};

export const getTitlePageMessageShopee = (type, platform_name = "") => {
    const messages = {
        10: () => trans(t`Đánh giá tại:`) + `  ${platform_name}`, //customer_comment
    };

    return messages[type] ? messages[type]() : "";
};

// Legacy constants - kept for backward compatibility
// Note: These won't work for dynamic translations, use functions above instead
export const TITLE_PAGE_MESSAGE = getTitlePageMessage;
export const TITLE_PAGE_MESSAGE_SHOPEE = getTitlePageMessageShopee;

export const getColorMessage = (messageType) => {
    const message = { message_type: messageType };
    if (isCustomerMessage(message)) {
        return {
            color: "#1a1a1a",
            backgroundColor: "#e8e8e8",
        };
    } else if (isSellerPrivateMessage(message)) {
        return { color: "#fff", backgroundColor: successColor };
    } else if (messageType === MessageType.SYSTEM_BOT_INFO) {
        return { color: "#555555", backgroundColor: "#ffffff" };
    } else if (messageType === MessageType.SYSTEM_INTERNAL_SELLER_MESSAGE) {
        return {
            color: "#1a1a1a",
            backgroundColor: "#ffffff",
            border: `1px solid ${infoColor}`,
        };
    } else if (isBotMessage(message) || isSystemMessage(message)) {
        return { color: "#555555", backgroundColor: systemMessageColor };
    } else {
        return { color: "#ffffff", backgroundColor: infoColor };
    }
};

export const COLOR_MESSAGE = {
    [MessageType.CUSTOMER_MESSAGE]: {
        color: "#1a1a1a",
        backgroundColor: "#e8e8e8",
    },
    [MessageType.CUSTOMER_COMMENT]: {
        color: "#1a1a1a",
        backgroundColor: "#e8e8e8",
    },
    [MessageType.CUSTOMER_REVIEW]: {
        color: "#1a1a1a",
        backgroundColor: "#e8e8e8",
    },

    [MessageType.CUSTOMER_CALL]: {
        color: "#1a1a1a",
        backgroundColor: "#e8e8e8",
    },

    [MessageType.CUSTOMER_CALL_TRANSCRIPT_MESSAGE]: {
        color: "#1a1a1a",
        backgroundColor: "#e8e8e8",
    },
    [MessageType.SELLER_MESSAGE]: {
        color: "#ffffff",
        backgroundColor: infoColor,
    },
    [MessageType.OTHER_SELLER_MESSAGE]: {
        color: "#fff",
        backgroundColor: successColor,
    },
    [MessageType.SYSTEM_BOT_INFO]: {
        color: "#555555",
        backgroundColor: "#ffffff",
    },
    [MessageType.SYSTEM_INTERNAL_SELLER_MESSAGE]: {
        color: "#1a1a1a",
        backgroundColor: "#ffffff",
        border: `1px solid ${infoColor}`,
    },
    90: { color: "#555555", backgroundColor: systemMessageColor },
    91: { color: "#555555", backgroundColor: systemMessageColor },
    92: { color: "#555555", backgroundColor: systemMessageColor },
    93: { color: "#555555", backgroundColor: systemMessageColor },
    94: { color: "#555555", backgroundColor: systemMessageColor },
    95: { color: "#555555", backgroundColor: systemMessageColor },
};

//todo: loading message mode
export const LOADING_MESSAGE_MODE = {
    error: "error",
    loading: "loading",
    success: "success",
    loading_more: "loading_more",
    loading_search: "loading_search",
    error_more: "error_more",
    end: "end",
};

//todo: send message mode
export const SEND_MESSAGE_MODE = {
    sending: "sending",
    sent: "sent",
    delivered: "delivered",
    error: "error",
    hidden: "hidden",
};

export const MESSAGE_SEND_STATUS = {
    sending: "sending",
    pending: "pending",
    error: "error",
    isSending: (status) => {
        return status === "sending" || status === "pending";
    },
};
